import { AddItemToCartCommand, CartModel, CreateOrderCommand, RemoveItemFromCartCommand } from "@core/services/api.service";

export class AddItemToCartAction {
    static readonly type = '[Cart] Add Item To Cart Action';

    constructor(public payload: { command: AddItemToCartCommand }) { }
}

export class AddItemToCartSuccessAction {
    static readonly type = '[Cart] Add To Cart Success Action';

    constructor(public payload: { CartModel: CartModel }) { }
}

export class AddItemToCartFailAction {
    static readonly type = '[Cart] Add To Cart Fail Action';

    constructor(public payload: { response: string }) { }
}

export class RemoveItemFromCartAction {
    static readonly type = '[Cart] Remove Item From Cart Action'
        ;
    constructor(public payload: { command: RemoveItemFromCartCommand }) { }
}

export class RemoveItemFromCartSuccessAction {
    static readonly type = '[Cart] Remove Cart Items Success Action';

    constructor(public payload: { CartModel: CartModel }) { }
}

export class RemoveItemFromCartFailAction {
    static readonly type = '[Cart] Remove Cart Items Fail Action';

    constructor(public payload: { response: string }) { }
}

export class ClearItemsFromCartAction {
    static readonly type = '[Cart] Clear Items From Cart Action';
}

export class ClearItemsFromCartSuccessAction {
    static readonly type = '[Cart] Clear Cart Items Success Action';

    constructor(public payload: { result: boolean }) { }
}

export class ClearItemsFromCartFailAction {
    static readonly type = '[Cart] Clear Cart Items Fail Action';

    constructor(public payload: { response: string }) { }
}

// export class UpdateTotalPriceAction {
//     static readonly type = '[Cart] Update Total Price';
//     constructor(public item: CartModel) {

//     }
// }

export class LoadCartItemsAction {
    static readonly type = '[Cart] Load UserCart Items';
}

export class LoadCartItemsSuccessAction {
    static readonly type = '[Cart] Load Cart Items Success';

    constructor(public payload: { CartModel: CartModel }) { }
}

export class LoadCartItemsFailAction {
    static readonly type = '[Cart] Load Cart Items Fail';

    constructor(public payload: { response: string }) { }
}

export class ClearCartStateAction {
    static readonly type = '[Cart] Clear Cart State';
}

export class ValidateCartPricesAndPlaceOrderAction {
    static readonly type = '[Cart] Validate Cart Prices And Place Order';

    constructor(public payload: { command: CreateOrderCommand }) { }
}
